import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Loader2, ShieldOff } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const ToolGuard = ({ toolKey, children }) => {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/api/product-configs/my-tools`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setAllowed((res.data.tools || []).includes(toolKey)))
      .catch(() => setAllowed(true));
  }, [toolKey]);

  if (allowed === null) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="w-6 h-6 animate-spin text-teal-600" />
      </div>
    );
  }

  if (!allowed) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="tool-access-denied">
        <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mb-4">
          <ShieldOff className="w-7 h-7 text-red-500" />
        </div>
        <h2 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>Access Restricted</h2>
        <p className="text-sm text-slate-500 mt-2 max-w-md">
          This tool is not included in your product access. Contact your team's Primary user to request access.
        </p>
        <Button className="mt-6 bg-teal-600 hover:bg-teal-700" onClick={() => navigate('/dashboard')} data-testid="access-denied-back-btn">
          Back to Dashboard
        </Button>
      </div>
    );
  }

  return children;
};
